module.exports = __webpack_public_path__ + "static/media/wedding08.2842e3b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding08.jpg
// module id = 428
// module chunks = 0